import React from "react";
import { useSite } from "../contexts/SiteContext";

const Ticker = () => {
  const { content } = useSite();
  const items = [...(content.ticker || []), ...(content.ticker || [])];
  return (
    <div className="ticker-wrap" aria-hidden="true">
      <div className="ticker-track">
        {items.map((t, i) => (
          <React.Fragment key={i}>
            <span className="ticker-item">{t}</span>
            <span className="ticker-item" style={{ padding: "0 4px" }}>
              <span className="ticker-dot" />
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
